import React from "react"

const TranslateLink = ({ text }) => (
  <a 
    style={{ marginLeft: 5 }}
    href={`https://translate.google.com/#zh-CN/es/${encodeURIComponent(text)}`}
    target="_blank"
    rel="noopener noreferrer"
  >
    𝔾 Traducir
  </a>
)

export default TranslateLink
